import React from "react";
import { useDispatch } from "react-redux";
import { signoutUser } from "../../../actions/login";
import Logo from "../../../assets/images/logo_medium.png";
import { StyledError } from "../../styled/error";

export default function LoadingComponent() {
  const dispatch = useDispatch();

  setTimeout(() => {
    dispatch(signoutUser());
  }, 4000);

  return (
    <StyledError.Root>
      <StyledError.Logo src={Logo} alt="" />
      <StyledError.Alert severity="warning" variant="filled">
        Redirigiendo...
      </StyledError.Alert>
    </StyledError.Root>
  );
}
